import React from 'react'
import { Query } from 'react-apollo'
import { withRouter } from 'react-router-dom'

import {
  GlobalHeader,
  SecondaryNavigation,
  Menu,
  MenuItem,
  UserAccountMenu
} from '../'

import { QUERY_CONTACT } from '../../queries'


class GlobalNavigation extends React.Component {
  state = {
    query: null,
    secondaryNavigationMenu: null,
    x: null,
    showUserMenu: null  // values can be 'null' or object of shape { user, employer }
  }

  getMenu = (employerIdentityId) => {
    switch (this.state.secondaryNavigationMenu) {
      case 'people':
        return [
          <Menu
            title='Employees'
            to='/os/people/employees'
            onClick={() => this.setState({ secondaryNavigationMenu: null, query: null })}
            className='slds-m-left_large'
            key='people_employees'
          />,
          <Menu
            title='Employers'
            to='/os/people/employers'
            onClick={() => this.setState({ secondaryNavigationMenu: null, query: null })}
            className='slds-m-left_large'
            key='people_employers'
          />,
          <Menu
            title='Contacts'
            to='/os/people/contacts'
            onClick={() => this.setState({ secondaryNavigationMenu: null, query: null })}
            className='slds-m-left_large'
            key='people_contacts'
          />
        ]

      case 'products':
        return [
          <Menu
            title='Credit'
            to='/os/products/credit'
            className='slds-m-left_large slds-p-left_large slds-p-right_large slds-p-bottom_large'
            key='products_credit'>
            <MenuItem
              name='Loans'
              to='/os/products/credit'
              onClick={() => this.setState({ secondaryNavigationMenu: null, query: null })}
            />
            <MenuItem
              name='Applications'
              to='/os/products/credit/applications'
              onClick={() => this.setState({ secondaryNavigationMenu: null, query: null })}
            />
          </Menu>,
          <Menu
            title='investment'
            to='/os/products/investments'
            className='slds-m-left_large slds-p-left_large slds-p-right_large slds-p-bottom_large'
            key='products_investment'>
            <MenuItem
              name='Investments'
              to='/os/products/investments'
              onClick={() => this.setState({ secondaryNavigationMenu: null, query: null })}
            />
            <MenuItem
              name='Withdrawals'
              to='/os/products/withdrawals'
              onClick={() => this.setState({ secondaryNavigationMenu: null, query: null })}
            />
            <MenuItem
              name='Withdrawal batches'
              to='/os/products/withdrawalbatches'
              onClick={() => this.setState({ secondaryNavigationMenu: null, query: null })}
            />
          </Menu>,
          <Menu
            title='Insurance'
            to='/os/products/insurance'
            className='slds-m-left_large slds-p-left_large slds-p-right_large slds-p-bottom_large'
            key='products_insurance'>
            <MenuItem
              name='Funeral cover'
              to='/os/products/insurance'  // NOTE: might have to change when we have other insurance products
              onClick={() => this.setState({ secondaryNavigationMenu: null, query: null })}
            />
          </Menu>
        ]

      case 'cases':
        return [
          <Menu
            title='Cases'
            to='/os/cases'
            onClick={() => this.setState({ secondaryNavigationMenu: null, query: null })}
            className='slds-m-left_large slds-p-bottom_large'
            key='cases_cases'
          />
        ]

      case 'operations':
        return [
          <Menu
            title='general'
            to='/os/operations/general/tasks'
            className='slds-m-left_large slds-p-left_large slds-p-right_large slds-p-bottom_large'
            key='operations_general'>
            <MenuItem
              name='Tasks'
              to='/os/operations/general/tasks'
              onClick={() => this.setState({ secondaryNavigationMenu: null, query: null })}
            />
            <MenuItem
              name='Payroll runs'
              to='/os/operations/general/payrollruns'
              onClick={() => this.setState({ secondaryNavigationMenu: null, query: null })}
            />
            <MenuItem
              name='Files'
              to='/os/operations/general/files'
              onClick={() => this.setState({ secondaryNavigationMenu: null, query: null })}
            />
            <MenuItem
              name='Workflows'
              to='/os/operations/general/workflows'
              onClick={() => this.setState({ secondaryNavigationMenu: null, query: null })}
            />
            <MenuItem
              name='Requests'
              to='/os/operations/general/requests'
              onClick={() => this.setState({ secondaryNavigationMenu: null, query: null })}
            />
          </Menu>,
          <Menu
            title='finance'
            className='slds-m-left_large slds-p-left_large slds-p-right_large slds-p-bottom_large'
            key='operations_finance'>
            <MenuItem
              name='Accounts'
              to='/os/operations/finance/accounts'
              onClick={() => this.setState({ secondaryNavigationMenu: null, query: null })}
            />
            <MenuItem
              name='Transactions'
              to='/os/operations/finance/transactions'
              onClick={() => this.setState({ secondaryNavigationMenu: null, query: null })}
            />
            <MenuItem
              name='Payments'
              to='/os/operations/finance/payments'
              onClick={() => this.setState({ secondaryNavigationMenu: null, query: null })}
            />
          </Menu>
        ]

      case 'communications':
        return [
          <Menu
            title='Communications'
            to='/os/communications'
            onClick={() => this.setState({ secondaryNavigationMenu: null, query: null })}
            className='slds-m-left_large'
            key='communications_communications'
          />,
          <Menu
            title='Create Request'
            toExternal='https://docs.google.com/forms/d/e/1FAIpQLSc1c7U2C2Yivdh7IMfw4ZX-5S_jnvyyHtfPRERgY2xzlYsU4Q/viewform?usp=sf_link'
            onClick={() => this.setState({ secondaryNavigationMenu: null, query: null })}
            className='slds-m-left_large'
            key='communications_request'
          />,
          <Menu
            title='Downloads'
            to='/os/downloads'
            onClick={() => this.setState({ secondaryNavigationMenu: null, query: null })}
            className='slds-m-left_large slds-p-bottom_large'
            key='communications_downloads'
          />
        ]

      case 'insights':
        return [
          <Menu
            title='Reports'
            to='/os/insights/reports'
            onClick={() => this.setState({ secondaryNavigationMenu: null, query: null })}
            className='slds-m-left_large slds-p-bottom_large'
            key='insights_reports'
          />
        ]

      default:
        return []
    }
  }

  performGlobalSearch = () => {
    if (this.state.query) {
      this.props.history.push(`/os/search/${this.state.query}`)
    }
  }

  getCurrentActivePageTabIndex = (pathname) => {
    switch(true) {
      case pathname.includes('deductions'):
        return 1

      case pathname.includes('employees'):
        return 2

      case pathname.includes('communications'):
        return 3

      case pathname.includes('payroll'):
        return 4

      default:
        return 0  // home
    }
  }

  render() {
    let internalUserNavLinks = [
      <li
        className='slds-tabs_default__item clickable'
        onMouseOver={() => this.setState({ secondaryNavigationMenu: null, x: null })}
        onClick={() => {
          this.setState({ query: null })
          this.props.history.push(`/os`)
        }}
        key='home'>
        <b>Home</b>
      </li>,
      <li
        className={`slds-tabs_default__item clickable ${this.state.secondaryNavigationMenu === 'people' ? 'slds-is-active' : ''}`}
        onMouseOver={() => this.setState({ secondaryNavigationMenu: 'people', x: 90 })}
        key='people'>
        <b>People</b>
      </li>,
      <li
        className={`slds-tabs_default__item clickable ${this.state.secondaryNavigationMenu === 'products' ? 'slds-is-active' : ''}`}
        onMouseOver={() => this.setState({ secondaryNavigationMenu: 'products', x: 24 })}
        key='products'>
        <b>Products</b>
      </li>,
      <li
        className={`slds-tabs_default__item clickable ${this.state.secondaryNavigationMenu === 'cases' ? 'slds-is-active' : ''}`}
        onMouseOver={() => this.setState({ secondaryNavigationMenu: 'cases', x: 303 })}
        onClick={() => this.props.history.push('/os/cases')}
        key='cases'>
        <b>Cases</b>
      </li>,
      <li
        className={`slds-tabs_default__item clickable ${this.state.secondaryNavigationMenu === 'operations' ? 'slds-is-active' : ''}`}
        onMouseOver={() => this.setState({ secondaryNavigationMenu: 'operations', x: 277 })}
        key='operations'>
        <b>Ops</b>
      </li>,
      <li
        className={`slds-tabs_default__item clickable ${this.state.secondaryNavigationMenu === 'communications' ? 'slds-is-active' : ''}`}
        onMouseOver={() => this.setState({ secondaryNavigationMenu: 'communications', x: 423 })}
        key='communications'>
        <b>Comms</b>
      </li>,
      <li
        className={`slds-tabs_default__item clickable ${this.state.secondaryNavigationMenu === 'insights' ? 'slds-is-active' : ''}`}
        onMouseOver={() => this.setState({ secondaryNavigationMenu: 'insights', x: 540 })}
        onClick={() => {
          this.setState({ query: null })
          this.props.history.push(`/os/insights/reports`)
        }}
        key='insights'>
        <b>Insights</b>
      </li>
    ]

    return (
      <React.Fragment>
        {JSON.parse(localStorage.getItem('isUserPicsaEmployee'))
          ? <GlobalHeader
              navigationLinks={internalUserNavLinks}
              searchValue={this.state.query || ''}
              onSearchChange={(e) => this.setState({ query: e.target.value })}
              onSearchClick={this.performGlobalSearch}
              onSearchClear={() => this.setState({ query: null })}
              onUserClick={(user, employer) => this.setState({
                showUserMenu: { user, employer }
              })}
            />
          : <Query query={QUERY_CONTACT} variables={{ identityId: localStorage.userDecodedID }}>
              {({ loading, error, data }) => {
                if (loading || error) {
                  return null
                }

                const currentPageTabIndex = this.getCurrentActivePageTabIndex(this.props.location.pathname)

                const defaultEmployerPortalNavLinks = [
                  <li
                    className={`slds-tabs_default__item ${currentPageTabIndex === 0 && 'slds-is-active'}`}
                    onClick={() => this.props.history.push(`/os/dashboard`)}
                    key='home'>
                    <b>Home</b>
                  </li>,
                  <li
                    className={`slds-tabs_default__item ${currentPageTabIndex === 1 && 'slds-is-active'}`}
                    onClick={() => this.props.history.push(`/os/operations/general/deductions`)}
                    onMouseOver={() => this.setState({ secondaryNavigationMenu: null, x: null })}
                    key='deductions'>
                    <b>Deductions</b>
                  </li>
                ]


                let navLinks = [...defaultEmployerPortalNavLinks]

                return (
                  <GlobalHeader
                    navigationLinks={navLinks}
                    onUserClick={(user, employer) => this.setState({
                      showUserMenu: { user, employer }
                    })}
                    hideSearch={true}
                  />
                )
              }}
            </Query>
        }
        {this.state.showUserMenu
          ? <UserAccountMenu
              user={this.state.showUserMenu.user}
              employer={this.state.showUserMenu.employer}
              onClickOutside={() => this.setState({ showUserMenu: null })}
            />
          : this.state.secondaryNavigationMenu &&
              <SecondaryNavigation
                menus={this.getMenu(localStorage.getItem('employer'))}
                startX={this.state.x}
                onMouseLeave={() => this.setState({ secondaryNavigationMenu: null })}
                className={`slds-p-left_xx-large slds-p-right_large slds-border_bottom${['products', 'operations'].indexOf(this.state.secondaryNavigationMenu) > -1 ? ' slds-grid' : ''}`}
              />
        }
      </React.Fragment>
    )
  }
}

export default withRouter(GlobalNavigation)



// WEBPACK FOOTER //
// ./src/components/global-navigation/index.js